// src/common/hooks/useModal.ts
import { useEffect } from "react";

export const useBottomModal = (isVisible: boolean, onClose: () => void) => {
  // useEffect(() => {
  //   const handleEsc = (e: KeyboardEvent) => {
  //     if (e.key === "Escape" && isVisible) {
  //       onClose();
  //     }
  //   };

  //   if (isVisible) {
  //     document.addEventListener("keydown", handleEsc);
  //     document.body.style.overflow = "hidden";
  //   }

  //   return () => {
  //     document.removeEventListener("keydown", handleEsc);
  //     document.body.style.overflow = "";
  //   };
  // }, [isVisible, onClose]);

    const handleBackdropClick = (e: React.MouseEvent) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    };

  return { handleBackdropClick };
};
